<template>
  <v-container>
    <v-row>
      <v-col sm="12">
        <div
          v-if="documentData"
          class="text-center image-container"
        >
          <!-- <img :src="documentData" /> -->
          <object
            :data="documentData"
            width="100%"
            height="100%"
          ></object>
        </div>
        <v-file-input
          v-model="files"
          @change="onFileChange"
          color="primary"
          label="File input"
          :show-size="true"
          :placeholder="$t('select_document')"
          prepend-icon="mdi-paperclip"
          outlined
          accept="image/*, application/pdf"
          :display-size="1000"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-row>
        <v-col
          md="4"
          v-if="types && types.length > 0"
        >
          <v-select
            v-model="docType"
            :items="computedTypes"
            :menu-props="{ maxHeight: '400' }"
            :label="$t('doc_type')"
            required
            color="primary"
            persistent-hint
          ></v-select>
        </v-col>
        <v-col :md="types && types.length > 0 ? '8' : '12'">
          <v-text-field
            v-model="text"
            :label="$t('description')"
            :rules="required"
            hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-row>
    <v-row>
      <v-col
        md="6"
        sm="12"
      >
        <my-datepicker
          v-model="dateInz"
          :label="$t('date_inz')"
          required="true"
        />
      </v-col>
      <v-col
        md="6"
        sm="12"
      >
        <my-datepicker
          v-model="dateEnd"
          :label="$t('date_end')"
          required="true"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        sm="12"
        class="text-center"
      >
        <v-btn
          v-on:click="uploadDocument"
          class="ma-1 elevation-1 v-size--default success"
        >{{ $t("upload_document") }}</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>         

<script>
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import Swal from "sweetalert2";

export default {
  name: "document-uploader",
  components: { MyDatepicker },
  props: {
    maxSize: {
      type: Number,
      default: 20,
    },
    regularImg: {
      type: String,
      default: "./img/image_placeholder.jpg",
    },
    types: Array,
    url: { type: String, default: "/auth/documenti/upload/certificato/" },
  },
  data() {
    return {
      dateInz: null,
      dateEnd: null,
      text: null,
      docType: null,
      modal1: false,
      modal2: false,
      documentData: null,
      files: null,
      required: [(value) => !!value || this.$t("required_field")],
    };
  },
  computed: {
    computedTypes: function () {
      let types = [];
      for (let type of this.types) {
        types.push({
          value: type,
          text: this.required.includes(type) ? "* " + type : type,
        });
      }
      return types;
    },
  },
  methods: {
    onUpload() {
      // console.log(this.file);
    },
    onFileChange(e) {
      let _ = this;
      if (!_.files) return;
      if (_.files) {
        if (_.files.size > _.maxSize * 1024 * 1024) {
          Swal.fire({
            type: "error",
            html: _.$t("over_max_size") + " " + _.maxSize + " Mb",
          });
          _.documentData = "";
          _.files = null;
          return;
        } else {
          _.createImage(_.files);
        }
      }
    },
    createImage(file) {
      let _ = this;
      let reader = new FileReader();
      let vm = this;

      reader.onload = (e) => {
        vm.documentData = e.target.result;
        _.files = null;
      };
      if (file) reader.readAsDataURL(file);
    },
    removeImage: function () {
      this.documentData = "";
      this.files = null;
    },
    uploadDocument: function () {
      let _ = this;
      this.chiamataAxios("PUT", _.url, {
        body: {
          dateInz: _.dateInz,
          dateEnd: _.dateEnd,
          text: _.text,
          type: _.docType,
          documento: _.documentData,
        },
        msg: "always",
        secTimeout: 500,
      }).then((response) => {
        if (response.msg.esito) {
          _.$emit("uploaded", response.data);
          _.dateInz = null;
          _.dateEnd = null;
          _.text = null;
          _.docType = null;
          _.documentData = null;
          _.files = null;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
